import { roundWithPrecision } from 'Utils/ranged';

export type MathOps = 'round' | 'floor' | 'ceil';
export type StepInput = string | Step;

export default class Step {
  numerator: number;
  denominator: number;
  accuracy: number;
  numeric: number;
  imperial = false;

  constructor(step: StepInput = '1/100') {
    if (step instanceof Step) {
      ({
        numerator: this.numerator,
        denominator: this.denominator,
        accuracy: this.accuracy,
        numeric: this.numeric,
        imperial: this.imperial,
      } = step);
      return;
    }
    let format = step;
    if (step === 'imperial') {
      format = '1/12//2';
      this.imperial = true;
    } else if (!format.includes('/')) {
      // '5'
      format += '/1//0';
    } else if (!format.includes('//')) {
      // '1/12'
      format += '//2';
    }
    [this.numerator, this.denominator, this.accuracy] = format
      .replace('//', '/')
      .split('/')
      .map((v) => +v);
    const rawNumeric = this.numerator / this.denominator;
    this.numeric = roundWithPrecision(rawNumeric, this.accuracy, 'round');
  }

  fit(value: number, method: MathOps = 'round'): string {
    const fitNum =
      (Math[method]((value * this.denominator) / this.numerator) * this.numerator) / this.denominator;
    return fitNum.toFixed(this.accuracy);
  }
}
